import { render } from "./StatListCard.vue?vue&type=template&id=04a2dd94"
import script from "./StatListCard.vue?vue&type=script&lang=js"
export * from "./StatListCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__